export default __webpack_public_path__ + "static/media/Belt of the Eternal Blaze.1cfa2f7c.jpg";